import { render } from "./Opera.svg?vue&type=template&id=419f2044"
const script = {}
script.render = render

export default script